// The plain-language names Find gives the backend's case statuses, order statuses and shipping
// methods (CASES-R21, ORDERS-R3, ORDERS-R24). A value not listed is shown as received.
const caseStatusLabels: Record<string, string> = {
  created: "Created",
  assigned: "Assigned",
  processing: "Processing",
  waiting: "Waiting",
  support: "Support",
  completed: "Completed",
  cancelled: "Cancelled",
};

const orderStatusLabels: Record<string, string> = {
  new: "New",
  in_progress: "In progress",
  out_for_delivery: "Out for delivery",
  completed: "Completed",
  cancelled: "Cancelled",
  error: "Error",
};

const shippingMethodLabels: Record<string, string> = {
  usps_priority: "USPS Priority",
  usps_priority_express: "USPS Priority Express",
  ups_next_day_air: "UPS Next Day Air",
  ups_second_day_air: "UPS 2nd Day Air",
  fedex_ground: "FedEx Ground",
  fedex_standard_overnight: "FedEx Standard Overnight",
  fedex_priority_overnight: "FedEx Priority Overnight",
};

const labelFrom = (labels: Record<string, string>) => (value: string) =>
  Object.prototype.hasOwnProperty.call(labels, value) ? labels[value] : value;

export const caseStatusLabel = labelFrom(caseStatusLabels);
export const orderStatusLabel = labelFrom(orderStatusLabels);
export const shippingMethodLabel = labelFrom(shippingMethodLabels);
